export default __webpack_public_path__ + "static/media/EM0333.34I-41684_-24965_0.a3cc23bf.jpg";